<ng-template #Liste
             let-grp>

    <!-- NOT: Operasyonlar Bölgesi -->
    <div class="item"
         *ngIf="grp?.userData?.FikoArayuz?.agactaGorunur"
         style="pointer-events: none;"
         [attr.data-uuid]="grp?.uuid">

        <div class="ui image medium label tree-item-container"
             style="background: transparent;outline: none;width: fit-content;"
             tabindex="0"
             [style.transform]="(grp?.liste?.length>0 || grp?.userData?.FikoParametreler?.length>0) ? 'translateX(-1.5rem)':''"
             [class.fiko-3d-hovered]="selectionState?.hoveredUuid === grp?.uuid"
             [class.fiko-3d-selected]="selectionState?.selectedUuids?.has(grp?.uuid)"
             [class.fiko-parent-of-selected]="selectionState?.parentPathUuids?.has(grp?.uuid)"
             [class.fiko-arama-soluk]="!aramaEslesme(grp)"
             [class.fiko-arama-vurgu]="agacArama && aramaEslesme(grp)"
             [class.fiko-feat-bastik]="grp?.userData?.FikoArayuz?.durum === 'bastirilmis'"
             [class.fiko-feat-hata]="grp?.userData?.FikoArayuz?.durum === 'hata'"
             [draggable]="grp?.siralanabilir ? true : false"
             (dragstart)="dragBasla($event, grp)"
             (dragover)="dragUstunde($event, grp)"
             (drop)="birak($event, grp)"
             (mouseenter)="onTreeItemHover(grp)"
             (mouseleave)="onTreeItemHoverEnd()"
             (keydown.f2)="renameBaslat(grp)"
             (contextmenu)="open($event, grp);$event.preventDefault();">
            <i class="icon"
               [class.minus]="grp?.userData.FikoArayuz?.listeGoster"
               [class.plus]="!grp?.userData.FikoArayuz?.listeGoster"
               style="color: white;pointer-events: all;"
               *ngIf="grp?.liste?.length>0 || grp?.userData?.FikoParametreler?.length>0"
               (click)="grp.userData.FikoArayuz.listeGoster=!grp.userData.FikoArayuz.listeGoster;CD.detectChanges();"></i>

            <span>
                <img [src]="grp?.userData?.FikoArayuz?.simge"
                     style="width: 20px !important;height: 20px;object-fit: contain;"
                     [class.fiko-gizli-simge]="!grp?.visible"
                     *ngIf="grp?.userData.FikoArayuz?.simge">

                <i class="icon eye fiko-goz"
                   [class.slash]="!grp?.visible"
                   [class.fiko-goz-kapali]="!grp?.visible"
                   title="Görünürlük"
                   (click)="gorunurlukToggle($event, grp)"></i>
            </span>
            <!-- <img src="/sistem/simgeler/gizli-kaplama.webp" *ngIf="!grp?.visible"
                style="position: absolute;transform: translateX(-100%);width: 24px !important;height: 24px !important;object-fit: contain;pointer-events: none;"> -->

            <i class="icon fiko-feat-rozet" *ngIf="grp?.userData?.FikoArayuz?.durum === 'bastirilmis'" title="Bastırılmış (üretime girmez)">ban</i>
            <i class="icon fiko-feat-rozet hata" *ngIf="grp?.userData?.FikoArayuz?.durum === 'hata'" title="Hata: bu özellik yeniden oluşturulamadı">exclamation triangle</i>

            <input *ngIf="duzenlenenUuid === grp?.uuid" class="fiko-ad-input"
                   [(ngModel)]="duzenleAd"
                   (click)="$event.stopPropagation()"
                   (keydown.enter)="renameKaydet(grp)"
                   (keydown.escape)="renameIptal()"
                   (blur)="renameKaydet(grp)" />

            <span *ngIf="duzenlenenUuid !== grp?.uuid" class="text"
                  [class.fiko-3d-selected]="selectionState?.selectedUuids?.has(grp?.uuid)"
                  (dblclick)="adCiftTik($event,grp)"
                  (click)="itemTiklandi($event,grp)"
                  uzunBas
                  [uzunBasSure]="250"
                  (uzunBasildi)="uzunBasMenu($event, grp)"
                  style="pointer-events: all;">{{grp?.name}}</span>

            <a class="ui circular icon label sag-buton"
               *ngFor="let komut of grp?.sagButonlar; trackBy: trackByBaslik"
               [title]="komut.baslik ?? ''"
               (click)="komut.tiklandi();CD.detectChanges();">
                <i class="icon {{ komut.simge }}">{{ komut.simgeYazi }}</i>
            </a>
        </div>

        <div *ngIf="grp?.userData.FikoArayuz?.listeGoster"
             style="margin-left: 2rem;">
            <!-- Parametre Bölümü (kompakt chip satırı — CATIA'da dialog gerekir, bizde ağaçta inline) -->
            <div class="fiko-param-satir" *ngIf="grp.userData.FikoParametreler?.length"
                 (click)="$event.stopPropagation()">
                <ng-container *ngFor="let prm of grp.userData.FikoParametreler; trackBy: trackByIsim">

                    <!-- Sayı: kompakt düzenlenebilir değer -->
                    <label class="fiko-param-chip" *ngIf="prm.turu=='Sayı'">
                        <span class="fp-ad">{{prm.isim}}</span>
                        <input type="number" class="fp-sayi" tabindex="0"
                               [min]="prm.ayar?.min ?? null" [max]="prm.ayar?.maks ?? null"
                               [step]="prm.ayar?.adim ?? 1" [ngModel]="prm.degeri"
                               (ngModelChange)="paramDegisti(prm, $event)"
                               (click)="$event.stopPropagation()" />
                        <span class="fp-birim" *ngIf="prm.ayar?.birim">{{prm.ayar.birim}}</span>
                    </label>

                    <!-- Açılır: seçenekli -->
                    <label class="fiko-param-chip" *ngIf="prm.turu=='Açılır'">
                        <span class="fp-ad">{{prm.isim}}</span>
                        <select class="fp-sec" tabindex="0" [ngModel]="prm.degeri"
                                (ngModelChange)="paramDegisti(prm, $event)"
                                (click)="$event.stopPropagation()">
                            <option *ngFor="let s of prm.ayar?.secenekler" [ngValue]="s.deger">{{s.etiket}}</option>
                        </select>
                    </label>

                    <!-- Çubuk: kompakt slider -->
                    <div class="fiko-param-cubuk" *ngIf="prm.turu=='Çubuk'">
                        <span class="fp-ad" *ngIf="prm.isim">{{prm.isim}}: {{prm.degeri}}</span>
                        <input type="range" [min]="prm.ayar?.min ?? 0" [max]="prm.ayar?.maks ?? 100"
                               tabindex="0" [ngModel]="prm.degeri" [step]="prm.ayar?.adim ?? 1"
                               (ngModelChange)="paramDegisti(prm, $event)" />
                    </div>

                    <!-- Renk -->
                    <label class="fiko-param-chip" *ngIf="prm.turu=='Renk'">
                        <span class="fp-ad" *ngIf="prm.isim">{{prm.isim}}</span>
                        <nz-color-picker nzSize="small" [ngModel]="prm.degeri"
                                         (ngModelChange)="paramDegisti(prm, $event)"></nz-color-picker>
                    </label>

                    <!-- Formül (f(x)): değer salt-okunur + formül metni -->
                    <label class="fiko-param-chip fp-formul" *ngIf="prm.turu=='Formul'"
                           [class.fp-hata]="prm.hata" [title]="prm.hata || prm.degeri"
                           (click)="$event.stopPropagation()">
                        <span class="fp-ad">{{prm.isim}}</span>
                        <span class="fp-fx" (click)="paramFormulDuzenle($event, prm)">ƒ(x)</span>
                        <span class="fp-formul-metin" (click)="paramFormulDuzenle($event, prm)">{{prm.degeri}}</span>
                    </label>

                </ng-container>
            </div>
            <!-- Liste Bölümü (Recursive Children) -->
            <div *ngFor="let itm of grp?.liste; trackBy: trackByUuid">
                <ng-container *ngTemplateOutlet="Liste; context:{ $implicit: itm }"></ng-container>
            </div>
        </div>

    </div>


</ng-template>

<ng-container *ngTemplateOutlet="Liste; context:{ $implicit: grup }"></ng-container>

<ng-template #itemMenu
             let-grup>
    <section class="item-menu">
        <div style="display: flex;align-items: center;justify-content: center;">
            <div
                 style="margin-bottom: 0.2rem;/*background: linear-gradient(11deg, #000000b4, transparent),linear-gradient(11deg, transparent, #b3b3b3);*/padding: 2px 10px;border-radius: 50vh;font-weight: bolder;color: white;/*text-shadow: 0 0 10px rgb(0 255 255 / 95%);*/pointer-events: all;font-size: 0.90em;">
                <img [src]="grup?.userData?.FikoArayuz?.simge"
                     style="width: 16px !important;height: 16px;object-fit: contain;">
                {{grup?.name ?? "FikoYT Obje" }}

            </div>
        </div>

        <div class="menuDiv" (click)="renameBaslat(grup);close();">
            <i class="ui icon edit"></i> Yeniden Adlandır
        </div>
        <hr />

        <ng-container *ngFor="let itm of grup?.sagMenu; trackBy: trackByBaslik">

            <ng-container [ngSwitch]="itm.tipi">
                <ng-container *ngSwitchCase="'Ayraç'">
                    <hr />
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <div class="menuDiv"
                         (click)="itm.tiklandi();close();">
                         <i class="ui icon {{ itm.simge }}">{{ itm.simgeYazi }}</i>
                         {{itm.baslik}}
                        </div>
                </ng-container>

                <ng-container *ngSwitchCase="'Grup'">
                    <span (click)="itm.tiklandi ? itm.tiklandi():null ;close();"
                          style="color: white;">
                        <i class="ui icon {{ itm.simge }}">{{ itm.simgeYazi }}</i>
                        {{itm.baslik}}
                    </span>
                    <div style="margin-left: 0.5rem;"
                         *ngFor="let altitm of itm?.alt; trackBy: trackByBaslik">
                        <ng-container *ngTemplateOutlet="menuitem; context:{ $implicit: altitm }"></ng-container>
                    </div>

                </ng-container>

            </ng-container>

        </ng-container>

    </section>
</ng-template>

<ng-template #menuitem
             let-item>
    <ng-container [ngSwitch]="item.tipi">
        <ng-container *ngSwitchCase="'Ayraç'">
            <hr />
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div class="menuDiv"
                 (click)="item.tiklandi();close();"
                 *ngIf="item.gorunur ? item.gorunur():true">
                <i class="ui icon {{ item.simge }}">{{ item.simgeYazi }}</i>
                {{item.baslik}}
            </div>
        </ng-container>
    </ng-container>
</ng-template>